import React from "react";
import { Form, DatePicker, Mentions, Input, Image, Button, Table, Divider } from 'antd';
import dayjs from 'dayjs';
import Widget from '../../Components/Theme/Widget/index.js';


const FormItem = Form.Item;

/**
 * A form that is used to search for a live schedule. It has two inputs, a dropdown to search for a schedule by date
 and a date picker for the start date.
 */
class SelectLiveScheduleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
            searchValue: ''
        };
    }

    handleSubmit = (e) => {
        this.props.handleLiveScheduleSubmit();
    };

    // handleConfirmBlur = (e) => {
    //     const value = e.target.value;
    //     this.setState({confirmDirty: this.state.confirmDirty || !!value});
    // };

    handleChange = (e) => {
        this.props.returnSearchValue(e.target.value);
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 6 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 18 },
            },
        };

        return (

            <Form scrollToFirstError={true} onSubmitCapture={this.handleSubmit} {...formItemLayout}
            initialValues={{searchValue: this.state.searchValue, startDate: dayjs()}}
            >
                <Divider/>
                {!this.props.liveScheduleSearch ?
                    <Form.Item label="resourceCollection" noStyle>
                        <Input
                            onClick={this.testClick}
                            name="resourceCollection"
                            placeholder={'Select a Schedule'}
                            onMouseDown={this.props.handleLiveScheduleSearch}
                            onChange={this.props.handleLiveScheduleSelect}
                            value={this.props.selectedLiveSchedule.name}
                            size={'large'}
                            required
                            suffix={<Image type={this.props.liveScheduleSearch ? 'up' : 'down'} />}
                        /> </Form.Item>

                    : <Form.Item name="searchValue">
                        <Input
                            type="text"

                            allowClear
                            required
                            onChange={this.handleChange}
                        ></Input>

                    </Form.Item>}

                <Form.Item style={{ marginTop: 10}} label="Start Date" labelAlign="left" name="startDate">


                        <DatePicker
                            onChange={this.props.handleLiveDateChange}
                            
                            format={'MM-DD-YYYY'}
                            required
                            styles={{
                                popup: {
                                    root: {
                                        zIndex: 2000
                                    }
                                }
                            }}
                        />
        
                </Form.Item>

                {this.props.liveScheduleSearch &&
                    (
                        <Widget>
                            <Table
                                columns={this.props.columns}
                                dataSource={this.props.dataSource}
                                size="small"
                                onRow={record => ({
                                    onClick: (e) => this.props.handleLiveScheduleSelect(record)
                                })}
                            />
                        </Widget>
                    )
                }

                <Form.Item wrapperCol={{xs:{span:24}, sm:{span:24}}}>
                    <Button  block color="primary" variant="solid" htmlType="submit">Submit</Button>
                </Form.Item>
                <Divider/>
            </Form>
        );
    }
}

export default SelectLiveScheduleForm;

